import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { handleErrorMessage } from '../../utils';
import ErrorHandler from '../Reusable/ErrorHandler';

class ModalForUpdateKjsName extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kjsName: props.kjs?.name || '',
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const kjsForUpdate = {
      ...this.props.kjs,
      name: this.state.kjsName,
    };

    this.props.updateKjs(kjsForUpdate);
  };

  render() {
    const { error, deleteError, t } = this.props || {},
      { Placeholders, Labels } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={this.props.secondModal && 'secondModal'}
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <h5 className="title mb-4">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="form-group">
                  <InputField
                    name="kjsName"
                    placeholder={Placeholders.kjsName}
                    onChange={this.onChange}
                    value={this.state.kjsName}
                    error={handleErrorMessage(
                      error,
                      'kjsName',
                      this.state.errors.kjsName
                    )}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(ModalForUpdateKjsName, 'ModalForUpdateKjsName');
